import React from 'react'
import { styled } from 'next-yak'

import { t, tc } from '@owl-nest/localize'
import { searchParams } from '@owl-nest/utils'
import * as plume from '@ulule/owl-kit-components/next'
import * as env from '@owl-nest/config'

type FollowProjectModalProps = {
  isOpen: boolean
  onClose: () => void
  userIsAuthenticated: boolean
}

const nextAwareURL = (url: string): string => {
  const params = { next: window.location.href }
  return searchParams.addSearchParamsToUrl(url, params)
}

export const FollowProjectModal = ({
  isOpen,
  onClose,
  userIsAuthenticated,
}: FollowProjectModalProps): React.ReactElement<FollowProjectModalProps> => (
  <ModalWithIcon
    closable
    open={isOpen}
    onClose={onClose}
    icon={<plume.illustrations.twoToned.EnvelopeWithHeart size={120} noBackground />}
    svgScale={0.825}
  >
    <ModalContent>
      <>
        {userIsAuthenticated ? (
          <>
            <plume.styles.heading.XXS>{t('Project followed')}</plume.styles.heading.XXS>
            <plume.styles.copy.S.regular>
              {t('You will receive project posts and be notified by email 48 hours before the end of the project.')}
            </plume.styles.copy.S.regular>
            <StyledCallToAction onClick={onClose}>{t('Ok, thanks')}</StyledCallToAction>
          </>
        ) : (
          <>
            <plume.styles.heading.XXS>{t('Follow this project')}</plume.styles.heading.XXS>
            <plume.styles.copy.S.regular>
              {tc(
                `[loginLink: Log in] to your Ulule account to follow this project. Don't have an account? [signupLink: Sign up] now.`,
                {
                  loginLink: <plume.Link href={nextAwareURL(env.SIGNIN_URL)} tinted />,
                  signupLink: <plume.Link href={nextAwareURL(env.SIGNUP_URL)} tinted />,
                },
              )}
            </plume.styles.copy.S.regular>
            <br />
            <plume.styles.copy.XS.regular>
              <plume.Link kind="secondary" onClick={() => onClose()}>
                {t('Later')}
              </plume.Link>
            </plume.styles.copy.XS.regular>
          </>
        )}
      </>
    </ModalContent>
  </ModalWithIcon>
)

const StyledCallToAction = styled(plume.styles.button.CallToAction)`
  // yak does not give a class to non exported styled-component with no css.
  // this is an issue because this component is used as a selector later in the file
  // to fix this we need to add a bogus css rule to force yak to generate a class
  // see : https://github.com/DigitecGalaxus/next-yak/issues/373
  --bogus-style: 0;
`

const ModalWithIcon = styled(plume.ModalWithIcon)``

const ModalContent = styled.div`
  text-align: center;

  ${StyledCallToAction} {
    margin-top: 30px;
  }

  ${plume.styles.heading.XXS} {
    margin-bottom: 10px;
    margin-top: 10px;
  }
`
